import { DataBean } from "../DataBean";

export class GoodsType extends DataBean {



    public async deleteGoodsType(idGoodsType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteGoodsType_Number", [idGoodsType]);
    }

    public async getGoodsTypeCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getGoodsTypeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}